import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IPurchaseHistoryFeature } from './purchase-history.feature.state';
import { PurchaseHistoryState } from './purchase-history.state';

export const getPurchaseHistoryState: MemoizedSelector<IPurchaseHistoryFeature, PurchaseHistoryState> = createFeatureSelector<
  PurchaseHistoryState
>(nameof<IPurchaseHistoryFeature>('purchaseHistoryFeature'));

export const getPurchaseHistoryItems = createSelector(getPurchaseHistoryState, (state: PurchaseHistoryState) => state.purchaseHistoryItems);

export const isLoading = createSelector(getPurchaseHistoryState, (state: PurchaseHistoryState) => state.isLoading);

export const failures = createSelector(getPurchaseHistoryState, (state: PurchaseHistoryState) => state.failures);
